import { LModal } from "@components";
import { ExamineeContactInfo } from "@fadmin/tabs/assessments/store/newExamineeSlice";
import { StartAssessmentBody } from "./StartAssessmentBody";

export const StartAssessmentModal = ({
    examinee,
    locationId,
    upcomingAssessmentId,
    onClose,
    onEditExamineeEmail
}: StartAssessmentModalProps): JSX.Element => {
    return (
        <LModal onClose={() => onClose?.()} width={"m"} fullHeight={false}>
            <StartAssessmentBody
                examinee={examinee}
                locationId={locationId}
                upcomingAssessmentId={upcomingAssessmentId}
                onEditExamineeEmail={onEditExamineeEmail}
            />
        </LModal>
    );
};

interface StartAssessmentModalProps {
    examinee: ExamineeContactInfo;
    locationId: number;
    upcomingAssessmentId?: number;
    onClose?: () => void;
    onEditExamineeEmail?: () => void;
}
